import React, { Fragment } from 'react'
import { Box, styled } from '@mui/material'
import { useIsSmallScreen } from 'packages/core'
import { useTranslation } from 'react-i18next'
import { ItemDetails, PeopleList } from 'components'
import { useMailboxOwners, useResponsibleParty } from 'hooks'
import useSubcomponents from 'useSubcomponents'
import { PersonDetails } from 'components/ApplicationBanner/PersonDetails'

const hasAccessToOwnerControl = 'ITShop-Mailboxes-Details-Owners-Control'
const hasAccessToResponsiblePartyControl = 'ITShop-Mailboxes-Details-ResponsibleParty-Control'

const PaddedDiv = styled(Box)({
    padding: '0 31px',
})

export const MoreInformationSection = ({ mailbox }: any) => {
    const { t } = useTranslation()
    const { hasAccessToControl } = useSubcomponents()
    const attributeOrientation = useIsSmallScreen() ? 'vertical' : 'horizontal'

    const { data: owners, isInitialLoading: ownersLoading } = useMailboxOwners(
        hasAccessToControl(hasAccessToOwnerControl) ? mailbox.id : null,
    )

    const {
        data: responsibleParty,
        isInitialLoading: responsiblePartyLoading,
    } = useResponsibleParty(
        mailbox.id,
        Boolean(hasAccessToControl(hasAccessToResponsiblePartyControl))
    )

    return (
        <Fragment>
            {ownersLoading || responsiblePartyLoading ? (
                <ItemDetails.AttributesContainer
                    data-ai-explain="Loading more information for this mailbox (owners and responsible party)."
                >
                    <PaddedDiv>
                        <ItemDetails.AttributesLoader />
                    </PaddedDiv>
                </ItemDetails.AttributesContainer>
            ) : (
                <ItemDetails.AttributesContainer
                    bottomPadding="0"
                    data-ai-explain="Mailbox more information: owners and responsible party when your permissions allow."
                >
                    {hasAccessToControl(hasAccessToOwnerControl) && (
                        <PaddedDiv
                            data-protectedsubcomponent={
                                hasAccessToOwnerControl
                            }
                            data-ai-explain="People or groups who own this mailbox."
                        >
                            <ItemDetails.Attribute
                                label={t('Common_Owners')}
                                value={<PeopleList list={owners} />}
                                orientation={attributeOrientation}
                            />
                        </PaddedDiv>
                    )}
                    {hasAccessToControl(hasAccessToResponsiblePartyControl) && (
                        <PaddedDiv
                            data-protectedsubcomponent={
                                hasAccessToResponsiblePartyControl
                            }
                            data-ai-explain="Responsible party or primary owner contact for this mailbox."
                        >
                            <ItemDetails.Attribute
                                label={t('Applications_Owner')}
                                value={
                                    responsibleParty ?
                                        <PersonDetails
                                            size="medium"
                                            person={{
                                                imageThumbUrl: responsibleParty.imageThumbUrl,
                                                friendlyName: responsibleParty.friendlyName,
                                                email: responsibleParty.email,
                                                telephone: responsibleParty.telephone,
                                            }}
                                        />
                                        : <>-</>
                                }
                                orientation={attributeOrientation}
                            />
                        </PaddedDiv>
                    )}
                </ItemDetails.AttributesContainer>
            )}
        </Fragment>
    )
}
